export const sharedConstants: { appName: string } = {
  appName: 'common'
};
